import React from 'react';
import { motion } from 'framer-motion';
import { ReactComponent as Asset1 } from '../assets/Asset1.svg';
import { ReactComponent as Asset2 } from '../assets/Asset2.svg';

export default function AnimatedLogo() {
  return (
    <div className="flex justify-center items-center mb-6 relative w-36 h-36 sm:w-44 sm:h-44 overflow-visible">
      {/* Asset2 - reveal from left to right */}
      <div className="absolute inset-0 flex justify-center items-end overflow-visible">
        <motion.div className="scale-150 w-full h-full flex justify-center items-center">
          <motion.div
            initial={{ clipPath: 'inset(0 100% 0 0)' }}
            animate={{ clipPath: 'inset(0 0% 0 0)' }}
            transition={{ duration: 1.5, ease: 'easeOut' }}
            className="w-full h-full"
          >
            <Asset2 className="w-full h-full text-white" />
          </motion.div>
        </motion.div>
      </div>

      {/* Asset1 - shining star effect */}
      <motion.div
        className="absolute inset-0 flex justify-center items-end"
        initial={{ opacity: 0 }}
        animate={{
          opacity: [0.6, 1, 0.6],
          scale: [0.5, 0.55, 0.5],
        }}
        transition={{
          delay: 1.2,
          duration: 2,
          repeat: Infinity,
          repeatType: 'loop',
          ease: 'easeInOut',
        }}
      >
        <motion.div className="scale-60 translate-y-9">
          <Asset1 className="w-full h-full" />
        </motion.div>
      </motion.div>
    </div>
  );
}
